<template>
    <div class="row">
        <div class="col-sm-12 negro">Files</div>
    </div>
    <div class="row mt-3">
        <div class="col-sm-6">
            <input type="file" class="form-control" @change="handleFileUpload($event)" />
        </div>
        <div class="col-sm-6">
            <button @click="uploadFile()" class="btn btn-primary">
                Upload
            </button>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-sm-12">
            <ul class="no-bullets" v-if="files.length > 0">
                <li class="mt-2" v-for="file in files" :key="file.name">
                    <div class="row">
                        <div class="col-sm-6">
                            <i class="bi bi-collection me-1 text-primary"></i> <a href="#"
                                @click="downloadFile(file.name, $event)">{{ file.name }}</a>
                        </div>
                        <div class="col-sm-6">
                            <a v-if="!isConsultant" href="#" @click="deleteFile(file.name, $event)"><i
                                    class="bi bi-trash me-1 text-primary"></i></a>
                        </div>
                    </div>

                </li>
            </ul>

            <div v-else class="row">
                <div class="col-sm-12">Files not found</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "quote-files",
    props: ["idQuote", "behavior"],
    data: function () {
        return {
            newFile: null,
            files: [],
        };
    },
    mounted() {
        let self = this;
        this.$vtc.vtcFetch("/Quote/GetQuoteFiles?id=" + this.idQuote, null,"API2")
            .then(function (data) {
                self.files = data.files;
                console.log(self.files);
            });
    },
    computed: {
        isConsultant() {
            return this.$vtc.isConsultant();
        },
    },
    methods: {
        downloadFile(name, e) {
            e.preventDefault();
            let dir = process.env.VUE_APP_API_URL
            window.open(dir + "/Quote/DownloadQuoteFile?i=" + this.idQuote + "&n=" + name, "_blank");
        },
        deleteFile(name, e) {

            e.preventDefault();
            if (this.isConsultant) return;

            if (confirm("Are you sure to delete?")) {
                let self = this;
                this.$vtc.vtcFetch("/Quote/DeleteQuoteFile?i=" + this.idQuote + "&n=" + name, null,"API2")
                    .then(function () {
                        self.files = self.files.filter(function (el) { return el.name != name; });
                    });
            }

        },
        handleFileUpload(event) {
            this.newFile = event.target.files[0];
        },
        uploadFile() {
            if (this.newFile != null) {
                let formData = new FormData();
                formData.append("file", this.newFile);
                formData.append("quoteId", this.idQuote);

                let self = this;
                this.$vtc.vtcFetch("/Quote/UploadFile", formData,"API2").then(function () {
                    self.files.push({ name: self.newFile.name, size: self.newFile.size });
                    self.newFile = null;
                });
            }


        }
    }
}
</script>
<style scoped>
.negro {
    font-weight: bold;
}

ul.no-bullets {
    list-style-type: none;
    /* Remove bullets */
    padding: 0;
    /* Remove padding */
    margin: 0;
    /* Remove margins */
}
</style>
